import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=23edc8ac&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=23edc8ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23edc8ac",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23edc8ac')) {
      api.createRecord('23edc8ac', component.options)
    } else {
      api.reload('23edc8ac', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=23edc8ac&scoped=true&", function () {
      api.rerender('23edc8ac', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UxKOg6aFscaW/JS/comp/Voucher.vue"
export default component.exports